export default __webpack_public_path__ + "static/Polo-SemiBold-da934e8263f29957787e1f177b4b5f4d.ttf";